import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { HOME_PATH } from '@pace/domain';
import { useI18n } from '../i18n';
import { useSession } from '../session';

export function NotFound() {
  const { t } = useI18n();
  const { session } = useSession();
  return (
    <div className="center">
      <h1 className="display">{t('common.notFound')}</h1>
      <Link className="btn btn--primary" to={session ? HOME_PATH[session.role] : '/login'}>
        {t('common.goHome')}
      </Link>
    </div>
  );
}

/** Route-level error boundary: never a white screen on the floor. */
export function RouteError() {
  const err = useRouteError();
  const { t } = useI18n();
  if (isRouteErrorResponse(err) && err.status === 404) return <NotFound />;
  console.error(err);
  return (
    <div className="center">
      <h1 className="display">{t('common.somethingWrong')}</h1>
      <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
        {t('common.retry')}
      </button>
    </div>
  );
}
